// Copied angularjs helpers
function isString(value: any) {
  return typeof value === 'string';
}

function isNumber(value: any) {
  return typeof value === 'number';
}

export function escapeHTML(str: string) {
  str = '' + str;
  return str
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#039;');
}

export function pluralize(name: any) {
  if (!isString(name)) {
    return name;
  }
  return name.replace(/([^aeiou])y$/, '$1ie') + 's';
}

export function singularize(name: any) {
  if (!isString(name)) {
    return name;
  }
  return name.replace(/ies$/, 'y').replace(/s$/, '');
}

export function camalize(name: any) {
  if (!isString(name)) {
    return name;
  }
  return name
    .replace(/(?:^|[-_])(\w)/g, function (_: any, c: string) {
      return c ? c.toUpperCase() : '';
    })
    .replace(/^([A-Z])/, function (c: string) {
      return c.toLowerCase();
    });
}

export function initialize(name: any) {
  if (!name || !isString(name)) {
    return '';
  } else {
    const words = name.split(' ');
    if (words.length > 1) {
      return words[0].substring(0, 1).toUpperCase() + words[words.length - 1].substring(0, 1).toUpperCase();
    } else {
      return name.substring(0, 2).toUpperCase();
    }
  }
}

export function underscore(name: any) {
  if (!isString(name)) {
    return name;
  }
  return name.replace(/([A-Z])/g, function (c: string) {
    return '_' + c.toLowerCase();
  });
}

export function dash(name: any) {
  if (!isString(name)) {
    return name;
  }
  return name.replace(/([A-Z])/g, function (c: string) {
    return '-' + c.toLowerCase();
  });
}

export function classify(name: any) {
  if (!isString(name)) {
    return name;
  }
  const str = camalize(name);
  return str.charAt(0).toUpperCase() + str.substr(1);
}

export function truncate(str: any, length: number) {
  if (!isString(str) || !isNumber(length) || str.length < length) {
    return str;
  }

  return str.substr(0, length);
}

export function ellipsize(str: any, length: number) {
  if (!isString(str) || !isNumber(length) || str.length < length) {
    return str;
  }

  return truncate(str, length) + '...';
}

export function ordinal(n: any) {
  // http://stackoverflow.com/questions/12487422/take-a-value-1-31-and-convert-it-to-ordinal-date-w-javascript
  if (parseFloat(n) === parseInt(n) && !isNaN(n)) {
    const s = ['th', 'st', 'nd', 'rd'],
      v = n % 100;
    return n + (s[(v - 20) % 10] || s[v] || s[0]);
  }
  return n;
}
